import React from 'react';
import { RegisterForm } from '../components/Auth/RegisterForm';

export const RegisterPage: React.FC = () => {
  return <RegisterForm />;
};
